import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "c-safe-area-bottom"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["c-safe-area-bottom-wrap", [$props.areaClass]]),
    style: _normalizeStyle($props.areaStyle)
  }, [_renderSlot(_ctx.$slots, "default")], 6)]);
}